export const AnimationDuration = 200;
